// extracted by mini-css-extract-plugin
export default {"container":"SaveChangesFooter_container__rz2ut","visible":"SaveChangesFooter_visible__lj85e"};